const UPDATES = [
  { date: '2026-07-28', title: '《反派千金的生存法则》第128话更新', type: '章节更新', tag: '韩漫' },
  { date: '2026-07-28', title: '《剑术名家的独女》第95话上线', type: '章节更新', tag: '韩漫' },
  { date: '2026-07-27', title: '《咒术回战》第272话汉化完成', type: '汉化发布', tag: '日漫' },
  { date: '2026-07-27', title: '本周人气排行更新：韩漫板块大洗牌', type: '平台公告', tag: '排行' },
  { date: '2026-07-26', title: '《一人之下》第623话高清版上线', type: '章节更新', tag: '国漫' },
  { date: '2026-07-26', title: '新作入库《沦为公爵家的女仆》全集', type: '新作入库', tag: '韩漫' },
  { date: '2026-07-25', title: '《间谍过家家》第108话汉化发布', type: '汉化发布', tag: '日漫' },
  { date: '2026-07-25', title: '七月漫画人气排行榜正式发布', type: '平台公告', tag: '排行' },
];

const TYPE_COLORS: Record<string, string> = {
  '章节更新': 'bg-primary-100 text-primary-700',
  '汉化发布': 'bg-accent-100 text-accent-700',
  '平台公告': 'bg-secondary-100 text-secondary-700',
  '新作入库': 'bg-primary-100 text-primary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            实时追踪热门漫画更新进度，不再错过任何一话精彩内容
          </p>
        </div>

        <div className="max-w-[720px] mx-auto">
          {UPDATES.map((item, idx) => (
            <div
              key={idx}
              className="flex items-start gap-4 py-3.5 border-b border-background-200/50 last:border-none hover:bg-background-50/80 transition-colors rounded-lg px-3 cursor-default"
            >
              <span className="text-xs text-foreground-500 whitespace-nowrap mt-0.5 flex-shrink-0 w-[72px]">
                {item.date}
              </span>

              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-800 leading-relaxed">{item.title}</p>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${TYPE_COLORS[item.type] || 'bg-background-200 text-foreground-600'}`}>
                  {item.type}
                </span>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.tag}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}